import i18n from '@/plugins/i18n'
import { ContainerModule } from 'inversify';
import { FetchService, FetchErrorNotificationService, NotificationService,
         FetchErrorNotificationMessage } from '@xlearn/async-toolbox'
import { FetchServiceSymbol, FetchErrorNotificationServiceSymbol } from './symbol'
import { errorReporter } from '@/app/error-handling';
import { NotificationServiceSymbol } from '@/app/notification/service';

class FetchErrorNotificationTranslator implements FetchErrorNotificationMessage {
  public message(suffix: string): string {
    return i18n.t(`fetch.notification.${suffix}`).toString()
  }
}

export const fetchServiceModule = new ContainerModule((bind) => {
  bind(FetchServiceSymbol).toDynamicValue(() => {
    return new FetchService(errorReporter)
  }).inSingletonScope()

  bind(FetchErrorNotificationServiceSymbol).toDynamicValue((context) => {
    const fetchService = context.container.get<FetchService>(FetchServiceSymbol)
    const notificationService = context.container.get<NotificationService> (NotificationServiceSymbol)

    return new FetchErrorNotificationService(fetchService, notificationService,
                                             new FetchErrorNotificationTranslator(),
                                             errorReporter)
  }).inSingletonScope()
});

